import React from 'react'

const editLink = (editSection, complete, isActive) => {
  return (
    <a className="noselect" style={complete && !isActive ? {float: 'right', cursor: 'pointer', marginBottom: '20px'} : {display: 'none'}} onClick={editSection}>edit</a>
  )
}

export {editLink}
